import moment from "moment";

export default class FormattingService {
    public formatString(number: string, showDecimals: boolean = true, numberOfDecimals: number = 2): string {
        const numberFormatInput = number == null ? 0 : Math.abs(Number(number));
        const isShowDecimals = showDecimals || (numberFormatInput > 0 && numberFormatInput < 1)
        const decimalsToShow = isShowDecimals ? numberOfDecimals : 0;
        return Intl.NumberFormat(navigator.language, {
            minimumFractionDigits: decimalsToShow < 2? decimalsToShow: 2,
            maximumFractionDigits: decimalsToShow,
        }).format(Number.parseFloat(number))
    }

    public formatNumber(number: number, showDecimals: boolean = true, numberOfDecimals: number = 2): string {
        return this.formatString(number.toString(), showDecimals, numberOfDecimals);
    }

    /**
     * Formats a ratio as a percentage, e.g. 0.19542 as 19.542%.
     * @param value The ratio, as a number or a numeric string.
     * @param numberOfDecimals Decimals to show; 3 by default, as the allocation sheet views show.
     * @returns The percentage, or - when the value is missing or not a number.
     */
    public formatPercentage(value?: string | number, numberOfDecimals: number = 3): string {
        if (value == null || String(value).trim() === '' || Number.isNaN(Number(value))) {
            return '-';
        }
        return `${(Number(value) * 100).toFixed(numberOfDecimals)}%`;
    }

    public formatTimestamp(timestamp: number | string): string {
        return timestamp == null ? '' : moment(timestamp).format("YYYY-MM-DD HH:mm");
    }
}